/**
 * Tabela de logs de auditoria (drag-and-drop) no modal de detalhes da OS.
 * Exibida quando o usuário clica em "Logs" no footer; ordenação decrescente por timestamp.
 */
import './OrderDetailsAuditLogs.css';
import React from 'react';

const formatDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const cell = (v) => (v != null && v !== '' ? String(v) : '—');

export function OrderDetailsAuditLogs({ logs, loading, error }) {
  const tableFontSize = 10; /* 20% menor que 12px */
  if (loading) {
    return (
      <div className="order-details-audit-logs" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200, color: '#64748b', fontSize: tableFontSize }}>
        <span>Carregando logs…</span>
      </div>
    );
  }
  if (error) {
    return (
      <div className="order-details-audit-logs" style={{ padding: 16, color: '#dc2626', fontSize: tableFontSize, textAlign: 'center' }}>
        {error}
      </div>
    );
  }
  if (!logs || logs.length === 0) {
    return (
      <div className="order-details-audit-logs" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200, color: '#64748b', fontSize: tableFontSize }}>
        Nenhum log de movimentação para esta OS.
      </div>
    );
  }

  const rows = logs.map((log, index) => {
    const data = log.data && typeof log.data === 'object' ? log.data : {};
    return {
      id: logs.length - index,
      timestamp: log.timestamp,
      user_name: log.user_name,
      origem: data.origem,
      destino: data.destino,
      tecnicoCurrent: data.tecnicoCurrent,
      tecnicoNovo: data.tecnicoNovo,
      sessaoOrigem: data.sessaoOrigem,
      sessaoDestino: data.sessaoDestino,
    };
  });

  return (
    <div className="order-details-audit-logs" style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: 8 }}>
      <div style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        <table className="order-details-audit-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: tableFontSize }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 1, background: '#f8fafc', boxShadow: '0 1px 0 0 #e2e8f0' }}>
            <tr>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>#</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Data e hora</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Usuário</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Origem</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Destino</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Técnico atual</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Técnico novo</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Sessão (origem)</th>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Sessão (destino)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '8px 10px', color: '#64748b' }}>{r.id}</td>
                <td style={{ padding: '8px 10px', color: '#334155', whiteSpace: 'nowrap' }}>{formatDateTime(r.timestamp)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.user_name)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.origem)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.destino)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.tecnicoCurrent)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.tecnicoNovo)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.sessaoOrigem)}</td>
                <td style={{ padding: '8px 10px', color: '#334155' }}>{cell(r.sessaoDestino)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
